import React from "react";
import { FiMinus, FiPlus } from "react-icons/fi";

const QuantitySelector = ({ quantity, onChange, max = 9999, disabled = false }) => {
  const canDecrease = quantity > 1;
  const canIncrease = quantity < max;

  return (
    <div className="flex items-center gap-0 border border-gray-200 rounded-xl overflow-hidden w-fit">
      <button
        onClick={() => canDecrease && onChange(quantity - 1)}
        disabled={!canDecrease || disabled}
        className="w-10 h-10 flex items-center justify-center text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        aria-label="Decrease quantity"
      >
        <FiMinus size={14} />
      </button>
      <span className="min-w-[48px] h-10 flex items-center justify-center text-sm font-semibold text-gray-900 border-x border-gray-200 px-2">
        {quantity}
      </span>
      <button
        onClick={() => canIncrease && onChange(quantity + 1)}
        disabled={!canIncrease || disabled}
        className="w-10 h-10 flex items-center justify-center text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        aria-label="Increase quantity"
      >
        <FiPlus size={14} />
      </button>
    </div>
  );
};

export default QuantitySelector;
